import { useAppDispatch } from "../../../../redux/hooks";

import CustomButton from "../../../../components/CustomButton";
import { adminRoutes } from "../../../../router/routesConstants";

import { DevicesNomenclatureListInterface } from "../../../../redux/interfaces/admin.interface";
import SvgIcon from "../../../../helpers/SvgIcon";
import { getDownloadDevice } from "../../../../redux/api/admin.api";
import usePermissions from "../../../../router/usePermissions";
import userRoles from "../../../../constants/userRoles";
import withToggleStatusModal from "../hoc/withToggleStatusModal";

function DevicesNomenclatureActionButtons({
  itemId,
  crudData,
  tableContext,
  handleShowToggleModal,
}: {
  itemId: string;
  crudData: DevicesNomenclatureListInterface;
  tableContext: any;
  handleShowToggleModal?: (params: {
    device: DevicesNomenclatureListInterface;
    tableContext: any;
  }) => void;
}) {
  const dispatch = useAppDispatch();
  const { isAuthorized } = usePermissions();

  const isDeviceDisabled = crudData.status === 2;

  const goToUpdateDeviceNomenclature = () => {
    if (itemId) {
      return `${adminRoutes.assignUser}?idDevice=${itemId}&model=${crudData.model}`;
    }
  };

  const goToDeviceNomenclatureHistory = () => {
    if (itemId) {
      return `${adminRoutes.deviceHistory}?idDevice=${itemId}&sn=${crudData.sn}`;
    }
  };

  const handleDownloadDevice = async () => {
    if (itemId) {
      await dispatch(getDownloadDevice({ idDevice: itemId }));
    }
  };

  const handleOpenToggleModal = () => {
    if (handleShowToggleModal) {
      handleShowToggleModal({
        device: crudData,
        tableContext: tableContext,
      });
    }
  };

  return (
    <div>
      {isAuthorized(userRoles.DEVICES_NOMENCLATURE_CREATE) && (
        <>
          {!isDeviceDisabled && (
            <>
              <CustomButton
                variant="contained"
                tooltipTitle="Transfera"
                className="mt-1 me-1"
                navigate={goToUpdateDeviceNomenclature()}>
                <SvgIcon type="TRANSFER" />
              </CustomButton>
              {crudData.url && (
                <CustomButton
                  variant="contained"
                  tooltipTitle="Download"
                  className="mt-1 me-1"
                  onClick={handleDownloadDevice}>
                  <SvgIcon type="DOWNLOAD" />
                </CustomButton>
              )}
            </>
          )}

          <CustomButton
            variant="contained"
            tooltipTitle="Istoric"
            className="mt-1 me-1"
            navigate={goToDeviceNomenclatureHistory()}>
            <SvgIcon type="SPLIT_LIST" />
          </CustomButton>
        </>
      )}
      {isAuthorized(userRoles.DEVICES_NOMENCLATURE_CREATE) &&
        !isDeviceDisabled && (
          <CustomButton
            variant="contained"
            tooltipTitle={isDeviceDisabled ? "Restaureaza" : "Casare"}
            color={isDeviceDisabled ? "primary" : "error"}
            className="mt-1 me-1"
            onClick={handleOpenToggleModal}>
            <SvgIcon type={isDeviceDisabled ? "RESTORE" : "DELETE"} />
          </CustomButton>
        )}
    </div>
  );
}

export default withToggleStatusModal(DevicesNomenclatureActionButtons);
